import e from "./SourceTabs.module.js";
import { c as t } from "react/compiler-runtime";
import { memo as n } from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { Tab as a, Tabs as o } from "@jetbrains/ring-ui-built/components/tabs/tabs";
//#region src/components/SourceTabs/SourceTabs.tsx
var s = n((n) => {
	let a = t(18), s, l, u, d, f;
	a[0] === n ? (s = a[1], l = a[2], u = a[3], d = a[4], f = a[5]) : ({options: d, selected: f, onSelectTab: u, hint: s, ...l} = n, a[0] = n, a[1] = s, a[2] = l, a[3] = u, a[4] = d, a[5] = f);
	let p;
	a[6] === s ? p = a[7] : (p = s && /* @__PURE__ */ r("div", {
		className: e.hint,
		children: s
	}), a[6] = s, a[7] = p);
	let m;
	a[8] === d ? m = a[9] : (m = d.map(c), a[8] = d, a[9] = m);
	let h;
	a[10] !== u || a[11] !== f || a[12] !== m ? (h = /* @__PURE__ */ r(o, {
		selected: f,
		onSelect: u,
		className: e.tabs,
		titleContainerClassName: e.titles,
		tabContainerClassName: e.tabContent,
		children: m
	}), a[10] = u, a[11] = f, a[12] = m, a[13] = h) : h = a[13];
	let g;
	return a[14] !== l || a[15] !== p || a[16] !== h ? (g = /* @__PURE__ */ i("div", {
		className: e.container,
		...l,
		children: [p, h]
	}), a[14] = l, a[15] = p, a[16] = h, a[17] = g) : g = a[17], g;
});
function c(e) {
	return /* @__PURE__ */ r(a, {
		id: e.id,
		title: /* @__PURE__ */ r("span", {
			title: e.tooltip,
			children: e.title
		})
	}, e.id);
}
//#endregion
export { s as SourceTabs };
